// extracted by mini-css-extract-plugin
export default {"title":"LinkedAccounts_title__w7rwi","accounts":"LinkedAccounts_accounts__yYJoq","table":"LinkedAccounts_table__ZNOJk","body":"LinkedAccounts_body__Bcy2W"};